module.exports = __webpack_public_path__ + "static/media/college.78957f50.png";